module.exports = __webpack_public_path__ + "img/startConfigurationEarrings.a231c5b.webp";